"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUid = void 0;
function setupGetInstanceId() {
    let instanceId = 0;
    return function getInstanceId() {
        return ++instanceId;
    };
}
const getId = setupGetInstanceId();
function getUid(prefix = 'id') {
    return `${prefix}-${getId()}`;
}
exports.getUid = getUid;
//# sourceMappingURL=uid.js.map